import { graphql } from 'react-relay';

export const itemListEntryFragment = graphql`
    fragment ItemListEntry_component on ItemListEntry {
        id
        label
        value
        info
        indent
        valueInfo
    }
`;
